export default __webpack_public_path__ + "b269c3599328c8b96e45b8b94c778b28.png";